/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tokens: NonNullable<unknown>, cost: NonNullable<unknown> }} Chat_Tokens_LabelInputs */

const en_chat_tokens_label = /** @type {(inputs: Chat_Tokens_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tokens} tokens · ~${i?.cost}`)
};

const fr_chat_tokens_label = /** @type {(inputs: Chat_Tokens_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tokens} tokens · ~${i?.cost}`)
};

const ms_sg2_chat_tokens_label = /** @type {(inputs: Chat_Tokens_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tokens} token · ~${i?.cost}`)
};

/**
* | output |
* | --- |
* | "{tokens} tokens · ~{cost}" |
*
* @param {Chat_Tokens_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_tokens_label = /** @type {((inputs: Chat_Tokens_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tokens_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_tokens_label(inputs)
	if (locale === "fr") return fr_chat_tokens_label(inputs)
	return ms_sg2_chat_tokens_label(inputs)
});